import React from 'react';
import loadable from '@loadable/component';

const UserReviews = loadable(() =>
  import(/* webpackChunkName: "extra" */ './reviews')
);

const UserReviewsLoader = props => <UserReviews {...props} />;

export default UserReviewsLoader;
